export function isAuthError(message) {
  return message === 'Authentication required' || message === 'Login required' || message?.includes('Login required');
}

export function handleApolloError({ graphQLErrors, networkError, response, logout, captureException, captureMessage }) {
  if (graphQLErrors && graphQLErrors.length > 0) {
    const hasAuthError = graphQLErrors.some(({ message }) => isAuthError(message));
    if (hasAuthError) {
      logout({ returnTo: import.meta.env.VITE_HOME_URL });
      return;
    }
    graphQLErrors.forEach(({ message }) => captureMessage?.(message));
  }

  if (networkError) {
    if (networkError.error === 'login_required' || isAuthError(networkError.message)) {
      logout({ returnTo: import.meta.env.VITE_HOME_URL });
    } else {
      captureException?.(networkError);
    }
  }

  if (response) {
    response.errors = [];
  }
}
